var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSortLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8589 7.26811L10 11.2936L6.14108 7.26811C5.83679 6.91808 5.5325 6.91078 5.22822 7.24624C4.92393 7.58169 4.92393 7.90985 5.22822 8.23072L9.54357 12.7812C9.65422 12.9271 9.80636 13 10 13C10.1936 13 10.3458 12.9271 10.4564 12.7812L14.7718 8.23072C15.0761 7.90985 15.0761 7.58169 14.7718 7.24624C14.4675 6.91078 14.1632 6.91808 13.8589 7.26811Z",
    fill: "#242628",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSortLight);
export default __webpack_public_path__ + "static/media/ico-sort-light.e83f884fbb4826edea3b2e163c74e3bd.svg";
export { ForwardRef as ReactComponent };